export const REPORTS = {
  ACTIVITY_REPORT: 'Activity Report',
  RETAIL_STOCK_REPORT: 'Retail Stock Report',
  FX_REPORT: 'FX Stock',
  PFI_REPORT: 'PFI Report',
};

export const REPORT_LIST = [
  {
    key: 1,
    title: REPORTS.ACTIVITY_REPORT,
    pdfFileName: 'Activity-Report.pdf',
    printFileName: '_ActivityReport',
    summaryTitle: REPORTS.ACTIVITY_REPORT,
  },
  {
    key: 2,
    title: REPORTS.RETAIL_STOCK_REPORT,
    pdfFileName: 'Retail-Stock-Report.pdf',
    printFileName: '_RetailStockReport',
    excelFileName: 'Retail-Stock-Report.xlsx',
    summaryTitle: REPORTS.RETAIL_STOCK_REPORT,
  },
  {
    key: 3,
    title: REPORTS.FX_REPORT,
    pdfFileName: 'FX-Report.pdf',
    printFileName: '_FXReport',
    excelFileName: 'FX-Report.xlsx',
    summaryTitle: 'Currency Stock Report',
  },
  {
    key: 4,
    title: REPORTS.PFI_REPORT,
    pdfFileName: 'PFI-Report.pdf',
    printFileName: '_PFIReport',
    excelFileName: 'PFI-Report.xlsx',
    summaryTitle: REPORTS.PFI_REPORT,
  },
];

export const ACTIVITY_FILTER_LABELS = {
  ACTIVITY: 'Activity',
  USERS: 'Users',
  AMOUNT: 'Amount',
  PAYMENT_METHOD: 'Payment Method',
  VOID: 'Void',
  DATE_FROM: 'Date From',
  DATE_TO: 'Date To',
};
export const BASKET_TRANSACTION_TYPE = [
  {
    value: 'Bank Transfer',
    type: 'bankTransferAmount',
  },
  {
    value: 'Card',
    type: 'cardAmount',
  },
  {
    value: 'Cash',
    type: 'cashAmount',
  },
  {
    value: 'Online',
    type: 'onlineAmount',
  },
];

export const TRANSACTION_TYPE = {
  IN_AMOUNT: 'IN',
  OUT_AMOUNT: 'OUT',
  ACTIVITY: 'Activity',
  REFERENCE: 'Reference',
};

export const PLACEHOLDER_AMOUNT = 'Enter Amount';

export const ALL_VALUE = 'All';

export const SELECT_ALL_USERS = [
  {
    employeeName: ALL_VALUE,
    userId: -1,
  },
];

export const SELECT_ALL_ACTIVITY = [
  {
    id: 0,
    name: ALL_VALUE,
  },
];

export const ACTIVITY_REPORT_HEADERS = {
  UPDATED_ON: {
    NAME: 'updatedOn',
    TITLE: 'Date & Time',
  },
  ACTIVITY: {
    NAME: 'activityDetails',
    TITLE: 'Activity',
  },
  CUSTOMER_NAME: {
    NAME: 'customerName',
    TITLE: 'Customer Name',
  },
  REFERENCE: {
    NAME: '',
    TITLE: 'Reference',
  },
  NOTES: {
    NAME: 'notes',
    TITLE: 'Notes',
  },
  VOID: {
    NAME: 'isVoided',
    TITLE: 'Void',
  },
  IN: {
    NAME: 'inAmount',
    TITLE: 'In',
  },
  OUT: {
    NAME: 'outAmount',
    TITLE: 'Out',
  },
  PAYMENT_METHOD: {
    NAME: 'basket',
    TITLE: 'Payment Method',
  },
  USER_NAME: {
    NAME: 'userName',
    TITLE: 'User',
  },
};

export const FOOTER_BUTTONS = {
  PRINT: 'Print',
  EXPORT: 'Export',
  EXPORT_AS: 'Export As',
  PRINT_PAGE: 'Print Page',
};

export const DEFAULT_ACTIVITY_REPORT_FILTERS = {
  userId: -1,
  dateFrom: '',
  dateTo: '',
  activityGroupIds: 0,
  paymentType: '',
  isVoided: null,
};

export const RETAIL_STOCK_REPORT_FILTER_LABELS = {
  DATE: 'Date',
  CATEGORY: 'Category',
  BARCODE: 'Barcode',
  METAL_TYPE: 'Metal Type',
  FINENESS: 'Fineness',
  RETAIL_PRICE: 'Retail Price',
  LAYAWAY: 'Layaway',
};

export const PLACEHOLDER_RETAIL_REPORT = {
  BARCODE: 'Enter Barcode',
  RETAIL_PRICE: 'Enter Retail Price',
};

export const RETAIL_STOCK_REPORT_HEADERS = {
  CATEGORY: {
    NAME: 'categoryGroupName',
    TITLE: 'Category',
  },
  BARCODE: {
    NAME: 'barcode',
    TITLE: 'Barcode',
  },
  LEGACY_BARCODE: {
    NAME: 'legacyBarcode',
    TITLE: 'Legacy Barcode',
  },
  DESCRIPTION: {
    NAME: 'shortDescription',
    TITLE: 'Description',
  },
  METAL_TYPE: {
    NAME: 'metalType',
    TITLE: 'Metal Type',
  },
  FINENESS: {
    NAME: 'fineness',
    TITLE: 'Fineness',
  },
  WEIGHT: {
    NAME: 'weight',
    TITLE: 'Weight',
  },
  COST: {
    NAME: 'costPrice',
    TITLE: 'Cost',
  },
  RETAIL_PRICE: {
    NAME: 'retailPrice',
    TITLE: 'Retail Price',
  },
  LAYAWAY: {
    NAME: 'layway',
    TITLE: 'Layaway',
  },
};

export const ATTRIBUTE_ID = {
  METAL_TYPE: 2,
  FINENESS: 3,
};

export const YES_NO_OPTIONS = ['Yes', 'No'];

export const DEFAULT_RETAIL_STOCK_REPORT_FILTERS = {
  barcode: null,
  categoryId: 0,
  metalTypeId: 0,
  finenessId: 0,
  layway: null,
  retailPrice: null,
};

export const YES_NO_VALUE = {
  YES: 'Yes',
  NO: 'No',
};

export const FILE_TYPE = {
  PDF: 'PDF',
  EXCEL: 'Excel',
  CSV: 'CSV',
};

export const FX_REPORT_FILTER_LABELS = {
  DATE: 'Date',
  CURRENCY: 'Currency',
};

export const FX_REPORT_HEADERS = {
  CURRENCY_NAME: {
    NAME: 'currencyName',
    TITLE: 'Currency Name',
  },
  AMOUNT_IN_STORE: {
    NAME: 'amountInStore',
    TITLE: 'Total Amount in Store',
  },
  AMOUNT_IN_SAFE: {
    NAME: 'amountInMainSafe',
    TITLE: 'Amount in Safe',
  },
  AMOUNT_IN_TILLS: {
    NAME: 'amountInTills',
    TITLE: 'Amount in Tills',
  },
  GBP_EQUIVALENT: {
    NAME: 'sterling',
    TITLE: 'GBP Equivalent',
  },
};

export const SELECT_ALL_CURRENCY = [
  {
    currencyCode: '',
    currencyDescription: ALL_VALUE,
  },
];

export const REPORTS_WITH_EXPORT_AS_BUTTON = [
  REPORTS.RETAIL_STOCK_REPORT,
  REPORTS.FX_REPORT,
  REPORTS.PFI_REPORT,
  REPORTS.ACTIVITY_REPORT,
];

export const PFI_REPORT_HEADERS = {
  PFI_DATE: {
    NAME: 'pfiDate',
    TITLE: 'PFI Date',
  },
  ACTIVITY: {
    NAME: 'serviceType',
    TITLE: 'Activity',
  },
  REFERENCE: {
    NAME: 'serviceNumber',
    TITLE: 'Reference',
  },
  COST: {
    NAME: 'cost',
    TITLE: 'Cost',
  },
  BARCODE: {
    NAME: 'barcode',
    TITLE: 'Barcode',
  },
  LEGACY_BARCODE: {
    NAME: 'legacyBarcode',
    TITLE: 'Legacy Barcode',
  },
  WEIGHT: {
    NAME: 'weight',
    TITLE: 'Weight',
  },
  DESCRIPTION: {
    NAME: 'shortDescription',
    TITLE: 'Description',
  },
  CUSTOMER: {
    NAME: 'customerName',
    TITLE: 'Customer',
  },
};

export const PFI_REPORT_FILTER_LABELS = {
  ACTIVITY: 'Activity',
  REFERENCE: 'Reference',
  WEIGHT: 'Weight',
  DATE_FROM: 'Date From',
  DATE_TO: 'Date To',
};

export const DEFAULT_PFI_REPORT_FILTERS = {
  serviceType: null,
  serviceReferenceId: null,
  weight: 0,
  dateFrom: '',
  dateTo: '',
};

export const PFI_FILTER_PLACEHOLDER = {
  REFERENCE: 'Enter Reference',
  WEIGHT: 'Enter Weight',
};

export const SELECT_ALL_PFI_ACTIVITY = [ALL_VALUE, 'Pledge', 'Purchase'];

export const TRANSACTION_TYPE_REFERENCES = {
  PLEDGE: 'LoanReferences',
  PURCHASE: 'PurchaseReferences',
  RETAIL: 'RetailReferences',
  FX: 'FxTransactionReferences',
  CASHDELIVERY: 'FxTransactionReferences',
  THIRDPARTYCHEQUE: 'ThirdPartyReferences',
  LAYAWAY: 'LayawayReferences',
  WESTERNUNION: 'WesternUnionReferences',
};

export const DATE_FILTER_ERROR =
  'Add a date filter when filtering only by weight';
